import React from 'react'
import PropTypes from 'prop-types'
import { Button, ModalBody, ModalFooter, ModalHeader } from '@offerzen/pinata'
import SendTermsForm from '../SendTermsForm'

import styles from './styles'

const SendTermsContent = ({ hideWrapper, token, companyId, setIsLoading, title }) => (
  <>
    { title && <ModalHeader text={title} /> }
    <ModalBody className={styles.modalBody}>
      <p>
        Enter the details of your team member who is required to review and accept our terms.
        {' '}They’ll receive an email from OfferZen with a link to the terms.
      </p>
      <p>
        <span className={styles.semiBold}>Note:</span> we only need one member to accept the terms for your company.
      </p>
      <SendTermsForm
        companyId={companyId}
        token={token}
        setIsLoading={setIsLoading}
      />
    </ModalBody>
    <ModalFooter
      onCancel={hideWrapper}
      size="medium"
      className={styles.footer}
    >
      <Button
        label="Done"
        onClick={hideWrapper}
        size="medium"
        variant="outlined"
      />
    </ModalFooter>
  </>
)

SendTermsContent.propTypes = {
  companyId: PropTypes.string,
  token: PropTypes.string,
  title: PropTypes.string,
  hideWrapper: PropTypes.func,
  setIsLoading: PropTypes.func,
}

export default SendTermsContent
